module.exports = __webpack_public_path__ + "static/media/basseng.dd74282a.svg";